import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface SentimentScore {
  positive: number;
  neutral: number;
  negative: number;
  total: number;
}

interface Comment {
  body: string;
  createOn: Date;
  id: number;
  question: {
    id: number;
  };
  replyCount: number;
  sentimentScore: SentimentScore;
  user: {
    id: number;
  };
}

interface CommentsSlice {
  isLoading: boolean;
  positiveComments: Comment[];
  error: string;
}

const initialState: CommentsSlice = {
  isLoading: false,
  positiveComments: [],
  error: "",
};

export const getPositiveComments = createAsyncThunk(
  "getPositiveComments",
  async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/reports/boards/${id}/sentiment/positive-comments`
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const positiveCommentsSlice = createSlice({
  initialState,
  name: "board",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPositiveComments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPositiveComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.positiveComments = action.payload;
      })
      .addCase(getPositiveComments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
